import type EnType from '../en-US/search';

export default {
  'search.SearchBar.label': 'Pesquisar',
  'search.SearchModal.errorScreen.helpText': 'Você pode querer verificar sua conexão de rede.',
  'search.SearchModal.errorScreen.titleText': 'Não foi possível obter resultados',
  'search.SearchModal.footer.closeKeyAriaLabel': 'Tecla Escape',
  'search.SearchModal.footer.closeText': 'para fechar',
  'search.SearchModal.footer.navigateDownKeyAriaLabel': 'Seta para baixo',
  'search.SearchModal.footer.navigateText': 'para navegar',
  'search.SearchModal.footer.navigateUpKeyAriaLabel': 'Seta para cima',
  'search.SearchModal.footer.searchByText': 'Pesquisar por',
  'search.SearchModal.footer.selectKeyAriaLabel': 'Tecla Enter',
  'search.SearchModal.footer.selectText': 'para selecionar',
  'search.SearchModal.noResultsScreen.noResultsText': 'Nenhum resultado para',
  'search.SearchModal.noResultsScreen.reportMissingResultsLinkText': 'Informe-nos.',
  'search.SearchModal.noResultsScreen.reportMissingResultsText':
    'Acredita que esta consulta deveria retornar resultados?',
  'search.SearchModal.noResultsScreen.suggestedQueryText': 'Tente pesquisar por',
  'search.SearchModal.placeholder': 'Pesquisar documentos',
  'search.SearchModal.searchBox.cancelButtonText': 'Cancelar',
  'search.SearchModal.searchBox.resetButtonTitle': 'Limpar a consulta',
  'search.SearchModal.startScreen.favoriteSearchesTitle': 'Favoritos',
  'search.SearchModal.startScreen.noRecentSearchesText': 'Nenhuma pesquisa recente',
  'search.SearchModal.startScreen.recentSearchesTitle': 'Recentes',
  'search.SearchModal.startScreen.removeFavoriteSearchButtonTitle':
    'Remover esta pesquisa dos favoritos',
  'search.SearchModal.startScreen.removeRecentSearchButtonTitle':
    'Remover esta pesquisa do histórico',
  'search.SearchModal.startScreen.saveRecentSearchButtonTitle': 'Salvar esta pesquisa',
} satisfies typeof EnType;
